"use client";

import { Icon, Subtitle } from "@tremor/react";
import { Link } from "@/components/ui";
import { ArrowRightIcon } from "@heroicons/react/16/solid";
import React from "react";
export function IncidentHeaderSkeleton() {
  return <header className="flex flex-col gap-4" data-sentry-component="IncidentHeaderSkeleton" data-sentry-source-file="incident-header-skeleton.tsx">
      <Subtitle className="text-sm" data-sentry-element="Subtitle" data-sentry-source-file="incident-header-skeleton.tsx">
        <Link href="/incidents" data-sentry-element="Link" data-sentry-source-file="incident-header-skeleton.tsx">All Incidents</Link>{" "}
        <Icon icon={ArrowRightIcon} color="gray" size="xs" data-sentry-element="Icon" data-sentry-source-file="incident-header-skeleton.tsx" /> Incident Details
      </Subtitle>
    </header>;
}